import React from 'react';
import { connect } from 'react-redux';
import { fetchTimezonesIfNeeded, fetchLeadSourcesIfNeeded, updateUserLocal }
  from 'common/ducks/user';
import { fetchIndustriesIfNeeded } from 'common/ducks/industry';
import { fetchCategoriesIfNeeded } from 'common/ducks/categories';
import Step2 from 'registration/client/components/step2'

const mapStateToProps = ({user, industry, categories}) => ({
  user,
  industryChoices: industry.data.map((i) => ({field: i.id, label: i.name})),
  categoryChoices: categories.data.map((c) => ({field: c.id, label: c.name}))
})

export default connect(mapStateToProps, {
  fetchTimezonesIfNeeded,
  fetchLeadSourcesIfNeeded,
  fetchIndustriesIfNeeded,
  fetchCategoriesIfNeeded,
  updateUserLocal
})(Step2);



// WEBPACK FOOTER //
// ./registration/client/containers/step2.jsx